import PropTypes from 'prop-types'
import React from 'react'
import Footer from "../components/footer/Footer";
import DesktopContainer from "../components/desktop/DesktopContainer";
import MobileContainer from "../components/mobile/MobileContainer";
import { renderToStaticMarkup } from "react-dom/server";
import translations from "../localisation/Translations.json";
import {withLocalize} from "react-localize-redux";

const ResponsiveContainer = ({children}) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

let supportedLanguages = [
  {name: "English", code: "en"},
  {name: "Japanese", code: "ja"}
];

export function defaultLanguage() {
  let preferredLanguage = window.navigator.language;
  return languageSupported(preferredLanguage) ? preferredLanguage : 'en';
}

function languageSupported(code) {
  return supportedLanguages.some(function (language) {
    return language.code === code;
  });
}

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.props.initialize({
      languages: supportedLanguages,
      translation: translations,
      options: { renderToStaticMarkup, defaultLanguage: defaultLanguage() }
    });
  }

  render() {
    return (
      <ResponsiveContainer>
        <Footer/>
      </ResponsiveContainer>
    )
  }
}

export default withLocalize(Home);



// WEBPACK FOOTER //
// ./src/pages/Home.js